import i18n from "../i18n"
import Filename from "./filename"

export const computeScaleAdaptedToFrame = (stage, media) => {

    if(stage.width > media.width && stage.height > media.height)
    {
        return 1
    }

    const ratioX = stage.width / media.width
    const ratioY = stage.height / media.height

    if(ratioX < ratioY)
    {
        return ratioX
    }

    return ratioY
}

export function updateCursor(cursor)
{
    return (event) => {
        event.target.getStage().container().style.cursor = cursor
    }
}

export function computeFilename(recordTitle, referenceCode, appName, mediaPosition, groupPosition, extension)
{
    const maxRecordTitleLength = 150
    const filename = new Filename(i18n.t('visualizer:download.filenameBase', { mediaPosition, groupPosition }), extension)

    return filename
        .prepend(referenceCode)
        .prependSubstring(recordTitle, maxRecordTitleLength)
        .append(appName)
        .value()
}
